// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import evaluateField from './evaluateField';

export const get = (doc, key) => {
    for (const f of (doc?.metadata ?? [])) {
        if (f.key.trim().toLowerCase() !== key.trim().toLowerCase()) continue;
        return evaluateField(doc.metadata, key, true);
    }
    return 0;
};


export const checkIsDigit = (field) => {
    if (typeof field === "number") return true;
    if (typeof field === "string" && field.trim() !== '') {
        return !isNaN(Number(field));
    }
    return false;
};


export default (doc) => {
    if (!doc?.metadata?.find(f => f.key === 'ending balance')) return 0;

    // Define keys and fetch their corresponding values
    // we only really want to run the TA reconciliation on these particular metadata fields, nothing else.
    const keys = ['beginning balance', 'ending balance', 'tx: deposits', 'tx: withdrawals', 'tx: income', 'tx: fees', 'tx: transfers', 'tx: other','tx: reinvestments', 'tx: loan payments', 'tx: receivables', 'gain/loss'];
    const values = keys.map(key => ({
        key,
        value: get(doc, key)
    }));

    // Check for invalid numeric fields
    let invalidFields = values.filter(v => !checkIsDigit(v.value)).map(v => v.key.toUpperCase());
    if (invalidFields.length > 0) {
        return `ERROR - Invalid value or formula in the following field(s): ${invalidFields.join(', ')}. Please click "Show more fields..." above this message to view and correct the errors.`;
    }

    // Calculate total by summing all fields except 'ending balance'
    const total = values
        .filter(v => v.key !== 'ending balance')
        .reduce((acc, v) => acc + parseFloat(v.value), 0);

    const ending = parseFloat(values.find(v => v.key === 'ending balance').value);

    // Check if the calculated total matches the ending balance
    if (total.toFixed(2).replace('-0', '0') === ending.toFixed(2).replace('-0', '0')) {
        return true; // Reconciled
    }

    // Return the difference, formatted to handle negative zeros
    return Math.abs(ending - total).toFixed(2).replace('-0', '0'); // Failed to reconcile
};

